export default function ErrorCircleIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={Math.round((size * 17) / 16)}
        viewBox='0 0 16 17'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.00008 2.50033C4.68637 2.50033 2.00008 5.18662 2.00008 8.50033C2.00008 11.814 4.68637 14.5003 8.00008 14.5003C11.3138 14.5003 14.0001 11.814 14.0001 8.50033C14.0001 5.18662 11.3138 2.50033 8.00008 2.50033ZM0.666748 8.50033C0.666748 4.45024 3.94999 1.16699 8.00008 1.16699C12.0502 1.16699 15.3334 4.45024 15.3334 8.50033C15.3334 12.5504 12.0502 15.8337 8.00008 15.8337C3.94999 15.8337 0.666748 12.5504 0.666748 8.50033Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.99992 5.16699C8.36811 5.16699 8.66659 5.46547 8.66659 5.83366V8.50033C8.66659 8.86852 8.36811 9.16699 7.99992 9.16699C7.63173 9.16699 7.33325 8.86852 7.33325 8.50033V5.83366C7.33325 5.46547 7.63173 5.16699 7.99992 5.16699Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.33325 11.1667C7.33325 10.7985 7.63173 10.5 7.99992 10.5H8.00659C8.37477 10.5 8.67325 10.7985 8.67325 11.1667C8.67325 11.5349 8.37477 11.8333 8.00659 11.8333H7.99992C7.63173 11.8333 7.33325 11.5349 7.33325 11.1667Z'
        />
      </svg>
    </span>
  );
}
